import React, { useEffect, useMemo, useParams, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import { Card } from "@mui/material";
import TableMaestros from "verticales/TableMaestros.tsx";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 54,
  pl: 2,
  pr: 2,
  pt: 0,
  pb: 2,
};

function TableActiveDirectory(props: any) {
  // declaracion de variables de la pantalla
  // console.log("Tabla Directorio", props);
  const [data, setData] = useState([]);
  const columns = useMemo(
    () => [
      { header: "Logontime", accessorKey: "Logontime" },
      { header: "Sessionname", accessorKey: "Sessionname" },
      { header: "Timeconnection", accessorKey: "Timeconnection" },
      { header: "Username", accessorKey: "Username" },
    ],
    []
  );

  return (
    <Grid item xs={12} md={12} lg={12}>
      <MDBox m={1}>
        <TableMaestros arrayColumns={columns} data={props.data} height={550} noActionsEdit={true} />
      </MDBox>
    </Grid>
  );
}

export default TableActiveDirectory;
